import { render, staticRenderFns } from "./VTscheduleAction.vue?vue&type=template&id=2d89113e&"
import script from "./VTscheduleAction.vue?vue&type=script&lang=js&"
export * from "./VTscheduleAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports